import toastUtils from "../../utils/ToastUtils";

export const showSuccessMessage = (message: string): void => {
  toastUtils.showMessage({ type: "success", message });
};

export const showWarningMessage = (message: string): void => {
  toastUtils.showMessage({ type: "warning", message });
};

export const showErrorMessage = (message: string): void => {
  toastUtils.showMessage({ type: "error", message });
};

export const showInfoMessage = (message: string): void => {
  toastUtils.showMessage({ type: "info", message });
};
